module.exports = __webpack_public_path__ + "img/logo-menu-branco.597363f4.png";